import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactDesignation } from "../../types/contactDesignations";
import { getActiveDesignations, getContactDesignations } from "../thunks/designationThunks";
import { ActiveDesignations } from "../../types/allcertificationdesignations";

interface DesignationState {
  contactDesignation: ContactDesignation | null;
  contactDesignations: ContactDesignation[] | null;
  activeDesignations: ActiveDesignations[] | null;
  loading: boolean;
  error: string | null;
  success: string | null;
}

const initialState: DesignationState = {
  contactDesignation: null,
  contactDesignations: [],
  activeDesignations: [],
  loading: false,
  error: null,
  success: null,
};

export const designationSlice = createSlice({
  name: "designation",
  initialState,
  reducers: {
    // optional manual setters if you still want to update state directly
    setContactDesignation: (state, action:PayloadAction<ContactDesignation>) => {
      state.contactDesignation = action.payload;
    },
    setContactDesignations: (state, action:PayloadAction<ContactDesignation[]>) => {
      state.contactDesignations = action.payload;
    },
      setActiveDesignations: (state, action:PayloadAction<ActiveDesignations[]>) => {
      state.activeDesignations = action.payload;
    },
    setError: (state, action:PayloadAction<string>) => {
      state.error = action.payload;
    },
    setLoading: (state, action:PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContactDesignations.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getContactDesignations.fulfilled, (state, action) => {
        state.loading = false;
        state.contactDesignations = action.payload.Data; // ✅ because API returns RootObjectOrganization with `.Data`
        state.success = "Organizations loaded successfully";
      })
      .addCase(getContactDesignations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      //Active Designation reducer
      .addCase(getActiveDesignations.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(getActiveDesignations.fulfilled, (state, action) => {
        state.loading = false;
        state.activeDesignations = action.payload.Data; // ✅ because API returns RootObjectOrganization with `.Data`
        state.success = "Designations loaded successfully";
      })
      .addCase(getActiveDesignations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setContactDesignation, setContactDesignations,setLoading, setError } = designationSlice.actions;

export default designationSlice.reducer;
